"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useStateCallback = function (initialState) {
    var _a = (0, react_1.useState)(initialState), state = _a[0], setState = _a[1];
    var cbRef = (0, react_1.useRef)(null);
    var setStateCallback = (0, react_1.useCallback)(function (state, cb) {
        if (cb === void 0) { cb = null; }
        if (cb) {
            cbRef.current = cb;
        }
        setState(state);
    }, []);
    (0, react_1.useEffect)(function () {
        if (cbRef.current) {
            // @ts-ignore
            cbRef.current(state);
            cbRef.current = null;
        }
    }, [state]);
    return [state, setStateCallback];
};
exports.default = useStateCallback;
//# sourceMappingURL=callback.js.map